module.exports = __webpack_public_path__ + "static/media/love-illustration.58383984.svg";